import { motion } from "framer-motion";
import beanGlasses from "@/assets/bean-glasses.svg";
import { trackClick } from "@/lib/analytics";

const HeroSection = () => {
  return (
    <section
      id="hello"
      className="section-dark min-h-[100dvh] flex flex-col justify-between px-5 md:px-10 lg:px-14 pt-20 lg:pt-0 pb-8"
    >
      <div className="flex-1 flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1 className="text-[clamp(4.5rem,12vw,7rem)] leading-[0.95] tracking-[-0.03em] text-foreground/90 font-display italic overflow-visible">
            <span className="block">We design</span>
            <span className="block ml-[5vw]">to influence.</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="mt-8"
        >
          <img
            src={beanGlasses}
            alt="KEISH Bean Mascot"
            className="w-32 md:w-40"
          />
        </motion.div>
      </div>

      {/* Bottom bar with tagline + CTA */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
        className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 pt-6 border-t border-border"
      >
        <p className="font-body text-ts-xs leading-relaxed text-muted-foreground max-w-md">
          A website should do more than look good. It can't just be trendy or
          "modern." Our websites load fast, make sense, and convert. If your
          website catches eyeballs but isn't securing sales, it's not doing its
          job. Pretty is easy. Performance is harder.
        </p>
         <div className="flex items-center gap-6">
           <a
             href="#portfolio"
             onClick={() => trackClick("cta", "hero_our_work")}
              className="inline-flex items-center gap-3 font-body text-ts-2xs font-medium tracking-[0.2em] uppercase text-foreground/80 group"
            >
              <span>Our Work</span>
              <span className="inline-block w-8 h-px bg-foreground/50 group-hover:w-12 transition-all" />
           </a>
           <a
             href="#services"
             onClick={() => trackClick("cta", "hero_our_services")}
              className="inline-flex items-center gap-3 font-body text-ts-2xs font-medium tracking-[0.2em] uppercase text-muted-foreground group"
            >
              <span>Our Services</span>
              <span className="inline-block w-8 h-px bg-muted-foreground/50 group-hover:w-12 transition-all" />
           </a>
         </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
